// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetApiKeysRequestModel from '../../model/get-api-keys-request-model';
import GetApiKeysRequestDTO from '../dto/get-api-keys-request-dto';
import dtoSchema from '../schemas/get-api-keys-request-schema';

export default abstract class GetApiKeysRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetApiKeysRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.userId = data.userId;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  userId?: number;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetApiKeysRequestDTO>): GetApiKeysRequestModel;
  static toModel(dto: DeepPartial<GetApiKeysRequestDTO> | undefined | null): GetApiKeysRequestModel | undefined;
  static toModel(dto: DeepPartial<GetApiKeysRequestDTO> | undefined | null): GetApiKeysRequestModel | undefined {
    return dto ? new GetApiKeysRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetApiKeysRequestModel> | GetApiKeysRequestModel): GetApiKeysRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      userId: unwrapped.userId,
      searchCriteria: unwrapped.searchCriteria,
    } as GetApiKeysRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetApiKeysRequestModel, can not map to GetApiKeysRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
